module.exports = __webpack_public_path__ + "static/img/5.6b3559f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/5/1/eng/5.png
// module id = 2G/f
// module chunks = 0